import { render } from "./RecoverPasswordModal.vue?vue&type=template&id=568ab379"
import script from "./RecoverPasswordModal.vue?vue&type=script&lang=ts"
export * from "./RecoverPasswordModal.vue?vue&type=script&lang=ts"
script.render = render

export default script